(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pxu-announcement-slider"] && !Shopify.designMode) return;
  try {
    
const { Section, Carousel } = window.PxuThemeSections;

class AnnouncementSliderSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.carousel = null;
    this.resizeTimeout = null;
    this.showArrows = this.data.show_arrows;
    this.observers = []; 
    this.onMount();
  }

  onMount() {
    if (!this.data.hasSlider) return;

    this.$root.classList.remove('pxu-announcement-slider--initialized');

    const options = {
      prevNextButtons: true,
      pageDots: false,
      groupCells: false,
      cellAlign: 'left',
      wrapAround: true,
      autoPlay: this.data.auto_rotate ? this.data.rotation_speed * 1000 : false,
    };

    this.carousel = new Carousel(this.$root, options);
    this.carousel.onMount();

    setTimeout(() => {
      this.adjustNavigationButtons();
      this.toggleButtonVisibility(this.showArrows);
      this.$root.classList.add('pxu-announcement-slider--initialized'); 
    }, 0);
  
    this.initEventListeners();
  }

  waitForElement(selector, callback) {
    const element = this.$root.querySelector(selector);
    
    if (element) {
      callback(element);
      return;
    }

    const observer = new MutationObserver((mutations, obs) => {
      const element = this.$root.querySelector(selector);
      if (element) {
        obs.disconnect();
        callback(element);
        this.observers = this.observers.filter(o => o !== obs); 
      }
    });

    observer.observe(this.$root, { childList: true, subtree: true });
    this.observers.push(observer); 
  }

  initEventListeners() {
    this.events.register(window, 'resize', () => {
      this.toggleButtonVisibility(false);
      clearTimeout(this.resizeTimeout);

      this.resizeTimeout = setTimeout(() => {
        this.adjustNavigationButtons();
        this.toggleButtonVisibility(this.showArrows);
      }, 200);
    });

    this.events.register(window, 'load', () => {
      this.adjustNavigationButtons();
      this.toggleButtonVisibility(this.showArrows);
    });

    this.events.register(document, 'keydown', (event) => {
      if (event.key === 'Tab') {
        this.toggleButtonVisibility(true);
      }
    });

    this.events.register(document, 'click', (event) => {
      if (this.showArrows === false && !event.target.closest('.flickity-prev-next-button')) {
        this.toggleButtonVisibility(false);
      }
    });

    this.toggleButtonVisibility(false);
  }

  toggleButtonVisibility(visible) {
    this.waitForElement('.flickity-prev-next-button', () => {
      const buttons = this.$root.querySelectorAll('.flickity-prev-next-button');
      buttons.forEach(button => {
        button.style.transition = visible ? 'opacity 0.2s ease-out' : 'none';
        button.style.opacity = visible ? '1' : '0';
        button.style.pointerEvents = visible ? 'auto' : 'none';
      });
    });
  }

  adjustNavigationButtons() {
    this.waitForElement('.flickity-prev-next-button', () => {
      const prevButton = this.$root.querySelector('.flickity-prev-next-button.previous');
      const nextButton = this.$root.querySelector('.flickity-prev-next-button.next');
      const announcements = this.$root.querySelectorAll('.pxu-announcement-slider__text');
      const viewport = window.innerWidth;
      const container = this.$root.querySelector('.pxu-section__container');

      if (!announcements.length || !container) return;

      let maxWidth = 0;
      announcements.forEach((el) => {
        const width = el.getBoundingClientRect().width;
        maxWidth = Math.max(maxWidth, width);
      });

      const containerRect = container.getBoundingClientRect();
      const minWidth = 650;
      let buttonOffset = 8;

      if (viewport >= 860) {
        const containerLeftEdge = containerRect.left;
        const containerRightEdge = viewport - containerRect.right;
        const announcementMaxWidth = maxWidth;
        const announcementLeftEdge = containerLeftEdge + (containerRect.width - announcementMaxWidth) / 2;
        const announcementRightEdge = containerRightEdge + (containerRect.width - announcementMaxWidth) / 2;

        if (maxWidth <= minWidth) {
          const leftGap = (announcementLeftEdge - containerLeftEdge) / 2;
          const rightGap = (containerRightEdge - announcementRightEdge) / 2;
          const maxOffset = Math.min(leftGap, rightGap);
          buttonOffset = maxOffset;
        }
      }

      prevButton.style.left = `${-buttonOffset}px`;
      nextButton.style.right = `${-buttonOffset}px`;
    });
  }

  onUnmount() {
    if (!this.carousel) return;
    this.carousel.onUnmount();
    this.carousel = null;
    this.events.unregisterAll();
    this.observers.forEach(observer => observer.disconnect());
    this.observers = [];
  }

  onBlockSelect(event) {
    if (!this.carousel) return;
    const $slide = event.target.parentElement;
    this.carousel.selectSlide($slide);
  }
}

document.querySelectorAll('[data-pxu-announcement-slider]').forEach(($section) => {
  Section.init($section, AnnouncementSliderSection);
});

if (Shopify.designMode) {
  window.PxuThemeSections.AnnouncementSliderSection = AnnouncementSliderSection;
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-logo-list"] && !Shopify.designMode) return;
  try {
    
const { Section, Carousel } = window.PxuThemeSections;
class LogoListSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.carousel = null;

    this.onMount();
  }

  onMount() {
    if (!this.data.hasSlider) return;
    this.carousel = new Carousel(this.$root, {
      draggable: true,
      groupCells: true,
      cellAlign: 'left'
    });
    setTimeout(() => {
      this.carousel.onMount();
    }, 100);
  }

  onUnmount() {
    if (!this.carousel) return;
    this.carousel.onUnmount();
    this.carousel = null;
  }

  onBlockSelect(event) {
    if (!this.data.hasSlider || !this.carousel) return;
    const $slide = event.target.parentElement;
    this.carousel.selectSlide($slide);
  }
}

document.querySelectorAll(`[data-pxu-logo-list]`).forEach(($section) => {
  Section.init($section, LogoListSection);
});

// Export for theme editor instance management.
if (Shopify.designMode) {
  window.PxuThemeSections.LogoListSection = LogoListSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-scrolling-images"] && !Shopify.designMode) return;
  try {
    
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

class ScrollingImages extends HTMLElement {
  constructor() {
    super();
    this.paused = false;
  }

  // Section lifecycle

  connectedCallback() {
    this.scrollingImageContent = this.querySelectorAll('[data-scrolling-image-content]'); // wrapper containing images
    if (!this.scrollingImageContent.length) return;
    this.pauseOnHover = this.getAttribute('pause-on-hover') === 'true';
    this.#initScroll();
    this.#handleResize();
    this.#setupTouchClick();
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.unobserve(this);
      this.observer = null;
    };
    if (this.ro) {
      this.ro.unobserve(this);
      this.ro = null;
    };
  }

  #handleResize() {
    if (this.ro) return;

    this.ro = new ResizeObserver(
      debounce(() => {
        this.#initScroll();
      }, 50)
    );

    this.ro.observe(this);
  }

  #initScroll() {
    this.scrollingImageContent.forEach((el) => {
      // Get gap from custom element attributes instead of computed style
      const isDesktop = window.matchMedia('(min-width: 480px)').matches;
      const imageGap = parseInt(
        isDesktop 
          ? this.getAttribute('image-gap-desktop') 
          : this.getAttribute('image-gap-mobile'),
        10
      );
      
      const marqueeItems = el.querySelectorAll(
        '[data-scrolling-image-content-item]:not([data-is-clone])'
      );
      
      const width = el.offsetWidth;

      // Calculate the total width of all marquee items using data attributes from individual items
      let totalItemWidth = [...marqueeItems].reduce(
        (total, item) => {
          const itemWidth = parseInt(
            isDesktop 
              ? item.dataset.desktopWidth 
              : item.dataset.mobileWidth,
            10
          );
          return total + (itemWidth + imageGap);
        },
        0
      );


      if (totalItemWidth > 0) totalItemWidth -= imageGap;

      // Ensure we have enough content for smooth infinite scroll (minimum 2 sets)
      const numImageGroups = Math.max(2, Math.ceil((width * 1.5) / Math.max(totalItemWidth, 1)));
      
      // Check how many clone groups we currently have
      const existingClones = el.querySelectorAll('[data-is-clone="true"]');
      const currentCloneGroups = existingClones.length / marqueeItems.length;
      
      // Only modify clones if the required number has changed
      if (Math.floor(currentCloneGroups) !== numImageGroups - 1) {
        // Remove existing clones
        existingClones.forEach(clone => clone.remove());
        
        // Clone and append marquee items if we don't have enough to fill the container
        for (let i = 1; i < numImageGroups; i++) {
          marqueeItems.forEach((item) => {
            const clone = item.cloneNode(true);
            clone.setAttribute('data-is-clone', 'true');
            el.appendChild(clone);
          });
        }
      }

      // Adjust animation duration based on the number of cloned groups to maintain consistent speed
      if (numImageGroups > 1) {
        const originalDuration = parseFloat(getComputedStyle(this).getPropertyValue('--duration'));
        const adjustedDuration = originalDuration * numImageGroups;
        el.style.setProperty('--duration', `${adjustedDuration}s`);
      }
    });

    if (!this.observer) {
      this.#observeAnimations();
    }
  }

  #observeAnimations() {
    // Initiate animations in viewport.
    this.observer = new IntersectionObserver(([entry]) => {
      const { isIntersecting } = entry;
      this.classList.toggle('scrolling-images--is-animated', isIntersecting);
    });
    this.observer.observe(this);
  }

  #setupTouchClick() {
    if (!window.matchMedia('(pointer: coarse)').matches || !this.pauseOnHover) return;
    
    this.addEventListener('click', (e) => {
      this.paused = !this.paused;
      this.scrollingImageContent.forEach((el) => {
        el.style.animationPlayState = this.paused ? 'paused' : 'running';
      });
    });
  }
}

customElements.define('scrolling-images', ScrollingImages);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-scrolling-text-with-icons"] && !Shopify.designMode) return;
  try {
    
const { debounce } = window.PxuUtils;

class PxuScrollingTextWithIcons extends HTMLElement {
  constructor() {
    super();
    this.paused = false;
  }

  connectedCallback() {
    this.controller = new AbortController();
    this.scrollingContent = this.querySelectorAll('[data-pxu-scrolling-text-with-icons-content]');
    if (!this.scrollingContent.length) return;
    this.pauseOnHover = this.getAttribute('pause-on-hover') === 'true';
    this.#initScroll();
    this.#handleResize();
    this.#setupTouchClick();
  }

  disconnectedCallback() {
    this.controller.abort();
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    if (this.ro) {
      this.ro.disconnect();
      this.ro = null;
    }
  }

  #handleResize() {
    if (this.ro) return;

    this.ro = new ResizeObserver(
      debounce(() => {
        this.#initScroll();
      }, 50)
    );

    this.ro.observe(this);
  }

  #initScroll() {
    this.scrollingContent.forEach((el) => {
      const marqueeItems = el.querySelectorAll(
        '[data-pxu-scrolling-text-with-icons-content-item]:not([data-pxu-scrolling-text-with-icons-clone])'
      );

      if (marqueeItems.length === 0) return;

      const width = el.offsetWidth;

      // Measure existing items so we know how much real estate they cover.
      const totalItemWidth = [...marqueeItems].reduce(
        (total, item) => total + item.offsetWidth,
        0
      );

      // Ensure we have enough content for smooth infinite scroll (minimum 2 sets).
      const numGroups = Math.max(
        2,
        Math.ceil((width * 1.5) / Math.max(totalItemWidth, 1))
      );

      // Check how many clone groups we currently have.
      const existingClones = el.querySelectorAll('[data-pxu-scrolling-text-with-icons-clone="true"]');
      const currentCloneGroups = existingClones.length / marqueeItems.length;

      // Only modify clones if the required number has changed.
      if (Math.floor(currentCloneGroups) !== numGroups - 1) {
        existingClones.forEach((clone) => clone.remove());

        for (let i = 1; i < numGroups; i++) {
          marqueeItems.forEach((item) => {
            const clone = item.cloneNode(true);
            clone.setAttribute('data-pxu-scrolling-text-with-icons-clone', 'true');
            // Strip IDs from clones so we don't violate uniqueness.
            clone.removeAttribute('id');
            // Mark clones as inert so screen readers don't read duplicates.
            clone.setAttribute('aria-hidden', 'true');
            el.appendChild(clone);
          });
        }
      }

      // Adjust animation duration based on the number of cloned groups
      // so visual speed stays consistent regardless of how much we cloned.
      if (numGroups > 1) {
        const originalDuration = parseFloat(
          getComputedStyle(this).getPropertyValue('--duration')
        );
        const adjustedDuration = originalDuration * numGroups;
        el.style.setProperty('--duration', `${adjustedDuration}s`);
      }
    });

    if (!this.observer) {
      this.#observeAnimations();
    }
  }

  #observeAnimations() {
    // Initiate animations only when the section is in viewport.
    this.observer = new IntersectionObserver(([entry]) => {
      const { isIntersecting } = entry;
      this.classList.toggle('pxu-scrolling-text-with-icons--is-animated', isIntersecting);
    });
    this.observer.observe(this);
  }

  #setupTouchClick() {
    if (!window.matchMedia('(pointer: coarse)').matches || !this.pauseOnHover) return;

    this.addEventListener('click', () => {
      this.paused = !this.paused;
      this.scrollingContent.forEach((el) => {
        el.style.animationPlayState = this.paused ? 'paused' : 'running';
      });
    }, { signal: this.controller.signal });
  }
}

if (!customElements.get('pxu-scrolling-text-with-icons')) {
  customElements.define('pxu-scrolling-text-with-icons', PxuScrollingTextWithIcons);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-testimonials"] && !Shopify.designMode) return;
  try {
    
const { Section, Carousel } = window.PxuThemeSections;

class TestimonialsSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.carousel = null;

    this.onMount();
  }

  onMount() {
    if (!this.data.hasSlider) return;

    const options = {
      prevNextButtons: true,
      groupCells: 3,
      cellAlign: 'left'
    };


    const mobileOptions = {
      draggable: true,
      cellAlign: 'left'
    };

    this.carousel = new Carousel(this.$root, options, mobileOptions);
    this.carousel.onMount();
  }

  onUnmount() {
    if (!this.carousel) return;
    this.carousel.onUnmount();
    this.carousel = null;
  }

  onBlockSelect(event) {
    if (!this.carousel) return;
    const $slide = event.target.parentElement;
    this.carousel.selectSlide($slide);
  }
}

document.querySelectorAll('[data-pxu-testimonials]').forEach(($section) => {
  Section.init($section, TestimonialsSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.TestimonialsSection = TestimonialsSection;
}

  } catch(e) { console.error(e); }
})();
})();
